import React, { Component } from "react";
import UserImage from "../user_image";

import { followUser } from "../../helper/follow_helper";
import { FriendsType } from "../../helper/type_helper";
import Modal from "react-modal";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class FollowView extends Component {
  state = { show: false };

  componentDidMount() {
    const self = this;
    setTimeout(function() {
      self.setState({ show: true });
    }, 100);
  }
  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    var style = { top: "-400px" };
    if (this.state.show === true) {
      style = { top: "0px" };
    }
    return (
      <div className="follow-views">
        <Modal className="follow-views" isOpen={true}>
          <div className="follow-return" onClick={this.handleCloseView} />
          <div style={style} className="follow-view center">
            <label className="name mt-4">
              {this.props.user.first_name} {this.props.user.last_name}
            </label>
            <br />
            <div className="image-profile center">
              <UserImage user={this.props.user} />
            </div>
            <br />
            <button
              className="btn btn_primary btn_yaystack btn_follow btn_close_friends"
              style={{ marginBottom: "10px", marginTop: "20px" }}
              onClick={this.handlerFollowCloseFriends}
            >
              {strings.close_friends}
            </button>
            <br />
            <button
              className="btn btn_primary btn_yaystack btn_follow btn_friends"
              style={{ marginBottom: "10px" }}
              onClick={this.handlerFollowFriends}
            >
              {strings.friends}
            </button>
            <br />
            <button
              className="btn btn_primary btn_yaystack btn_follow btn_acquaintance pb-2"
              style={{ marginBottom: "20px" }}
              onClick={this.handlerFollowAcquaintance}
            >
              {strings.acquaintance}
            </button>
          </div>
        </Modal>
      </div>
    );
  }

  handlerFollowCloseFriends = event => {
    event.preventDefault();
    this.handlerFollow(FriendsType.close_friends);
  };

  handlerFollowFriends = event => {
    event.preventDefault();
    this.handlerFollow(FriendsType.friends);
  };

  handlerFollowAcquaintance = event => {
    event.preventDefault();
    this.handlerFollow(FriendsType.acquaintance);
  };

  handlerFollow = friends_type => {
    this.handleCloseView();
    const self = this;
    this.followUserCall = followUser(this.props.user.username, friends_type);
    this.followUserCall.promise.then(answer => {
      self.props.handleAddFriend(
        answer.errors,
        self.props.user.username,
        friends_type
      );
    });
  };

  handleCloseView = event => {
    this.setState({ show: false });
    const self = this;
    setTimeout(function() {
      self.props.handleCloseView();
    }, 500);
  };
}

export default FollowView;



// WEBPACK FOOTER //
// ./src/components/profile/follow_view.jsx